import {useEffect, useState} from "react";
import Select from "react-select"
import styles from "../styles/ReactSelectStyles"
import dateUtils from "../utils/DateUtils";

const GenericInput = (props) => {

    const label = props.label;
    const [value, setValue] = useState()

    useEffect(() => {
        setValue(props.value)
    }, [props.value]);

    return (
        <>
            <div className="generic-label-container">
                <div className="label">{label}</div>
                <div className="label-content">
                    {value}
                </div>
            </div>
        </>
    )
}

export default GenericInput